import { useMemo } from 'react';
import { apolloClientFactory } from '@narvar/nth-apollo-client';
import { NormalizedCacheObject } from '@apollo/client';
import { LOMA_URL_CLIENT } from '../../constants/env';

type InitializeApolloClient = (options: {
  initialState?: NormalizedCacheObject;
}) => ReturnType<typeof apolloClientFactory> | null;

const createApolloClientForBrowser: InitializeApolloClient = ({
  initialState,
}) => {
  // Since this has to be run in the client and browser, we want to make sure we don't
  // return a browser apollo client on the server.
  if (typeof window === 'undefined') return null;

  const qs = new URLSearchParams(document.location.search);
  const maxBatch = qs.has('nobatch') ? 1 : undefined;

  return apolloClientFactory({
    fetch: window.fetch,
    uri: LOMA_URL_CLIENT,
    ssrMode: false,
    initialState,
    addTypename: true,
    maxBatch,
    // tell apollo to merge non-normalized cache objects, which was a breaking change in apollo v3
    // https://www.apollographql.com/docs/react/caching/cache-field-behavior/#merging-non-normalized-objects
    typePolicies: {
      RetailerTranslations: { merge: true },
      RetailerSettings: { merge: true },
      RetailerTheme: { merge: true },
      GlobalSettings: { merge: true },
    },
  });
};

const useApolloClientBrowser: InitializeApolloClient = (options) => {
  const store = useMemo(
    () => createApolloClientForBrowser(options),
    [options.initialState],
  );
  return store;
};

export default useApolloClientBrowser;
